import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { catchError, map } from 'rxjs/operators';

import { checkValidResponse, logError } from '@cigna/chcp/shared/util';
import { FlagUpdateType, FlaggedClaim, FlaggedPatient } from '../..';

@Injectable({
  providedIn: 'root',
})
export class UserFlagService {
  public flaggedApi: string;

  public CONSUMER_CODE = '1000';

  constructor(
    private http: HttpClient,
    @Inject('secureApi') secureApi: string,
  ) {
    this.flaggedApi = `${secureApi}/flag/v1`;
  }

  getFlaggedPatients() {
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.CONSUMER_CODE,
    );
    return this.http
      .get(`${this.flaggedApi}/benefits`, {
        params,
      })
      .pipe(
        map(checkValidResponse),
        map((res) => res.flaggedPatients),
        catchError(logError),
      );
  }

  getFlaggedClaims() {
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.CONSUMER_CODE,
    );
    return this.http
      .get(`${this.flaggedApi}/claims`, {
        params,
      })
      .pipe(
        map(checkValidResponse),
        map((res) =>
          res.flaggedClaims.filter(
            (claim: any) => claim.claimSummary.claimReferenceNumber,
          ),
        ),

        catchError(logError),
      );
  }

  updateFlaggedPatients(payload: {
    type: FlagUpdateType;
    data: FlaggedPatient[];
  }) {
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.CONSUMER_CODE,
    );

    const requestBody = {
      memberSummary: payload.data,
    };

    return this.http
      .put(`${this.flaggedApi}/benefit/${payload.type}`, requestBody, {
        params,
      })
      .pipe(map(checkValidResponse), catchError(logError));
  }

  updateFlaggedClaims(payload: { type: FlagUpdateType; data: FlaggedClaim[] }) {
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.CONSUMER_CODE,
    );

    const requestBody = {
      flagClaim: payload.data.map((fc) => ({
        tinNumbers: fc.tinNumbers,
        dateFlagged: fc.dateFlagged,
        member: {
          memberId: fc.member.memberId ? fc.member.memberId : '',
          memberFirstName: fc.member.memberFirstName,
          memberLastName: fc.member.memberLastName,
        },
        claimSummary: {
          claimReferenceNumber: fc.claimSummary.claimReferenceNumber,
          providerGeneratedAccountNumber: fc.claimSummary
            .providerGeneratedAccountNumber
            ? fc.claimSummary.providerGeneratedAccountNumber
            : '--',
          claimStatus: fc.claimSummary.claimStatus,
          medicare: fc.claimSummary.medicare,
          dateOfService: fc.claimSummary.dateOfService,
          dateProcessed: fc.claimSummary.dateProcessed,
          chargeAmount: fc.claimSummary.chargeAmount,
          claimCompositeKey: fc.claimSummary.claimCompositeKey,
          compositeClaimId: fc.claimSummary.compositeClaimId,
        },
      })),
    };

    return this.http
      .put(`${this.flaggedApi}/claim/${payload.type}`, requestBody, {
        params,
      })
      .pipe(map(checkValidResponse), catchError(logError));
  }
}
